import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';

interface Consents {
  analysis: boolean;
  deidentified_research: boolean;
  email_reminders: boolean;
  marketing: boolean;
}

export function useConsents() {
  return useQuery<{ consents: Consents }>({
    queryKey: ['mr-consents'],
    queryFn: () => api.get('/consents'),
  });
}

export function useUpdateConsents() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Consents>) =>
      api.post<{ consents: Consents }>('/consents', data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['mr-consents'] });
    },
  });
}
